import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import ArrowDownward from '@material-ui/icons/ArrowDownward';


const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class Viewhistory extends React.Component {
  state = {
    viewHistory: false,
    fullWidth: true,
    maxWidth: 'md',
  };

  handleClose = () => {
    this.setState({ viewHistory: false });
  };

  handleMaxWidthChange = event => {
    this.setState({ maxWidth: event.target.value });
  };

  handleFullWidthChange = event => {
    this.setState({ fullWidth: event.target.checked });
  };

  sort(data) {
    data.sort(function(a,b){
      return new Date(b.id) - new Date(a.id);
    });
    return data;
  }

  render() {
    const { classes } = this.props;
    let data = [];
    if (this.state.viewHistory) {
      data = this.props.data;
    }
    let i = 0;
    return (
      <React.Fragment>
        <div onClick={ () => { this.setState({ viewHistory: true }) }}>View</div>
        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}
          open={this.state.viewHistory}  onClose={this.handleClose} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Executive History</DialogTitle>
          <DialogContent>

          <table id="table" width="100%">
            <tr>
              <th style={{width: '10%'}}><center>Sino</center></th>
              <th style={{width: '50%'}}><center>Time</center></th>
              <th style={{width: '20%'}}><center>Menu</center></th>
              <th style={{width: '20%'}}><center>Action</center></th>
            </tr>
            { data.map((m) => {
                if(this.props.outTime == undefined) {
                  if (m.timestamp >= this.props.inTime) {
                    i++;
                    let icon = (<ArrowDownward style={{fontSize: 15, color: 'red'}} />);
                    if (m.action == "IN") {
                      icon = (<ArrowUpward style={{fontSize: 15, color: 'green'}} />);
                    }
                    return (
                      <tr>
                        <td><center>{i}</center></td>
                        <td><center>{m.timestamp}</center></td>
                        <td><center>{m.menu}</center></td>
                        <td><center>{icon}</center></td>
                      </tr>
                    )
                  }
                }
                else {
                  if (m.timestamp >= this.props.inTime && m.timestamp <= this.props.outTime) {
                    i++;
                    let icon = (<ArrowDownward style={{fontSize: 15, color: 'red'}} />);
                    if (m.action == "IN") {
                      icon = (<ArrowUpward style={{fontSize: 15, color: 'green'}} />);
                    }
                    return (
                      <tr>
                        <td><center>{i}</center></td>
                        <td><center>{m.timestamp}</center></td>
                        <td><center>{m.menu}</center></td>
                        <td><center>{icon}</center></td>
                      </tr>
                    )
                  }
                }
              })
            }
          </table>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

Viewhistory.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Viewhistory);
